(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('consortium-personal-seguros', {
                parent: 'entity',
                url: '/consortium-personal-seguros?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumPersonalSeguro'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-personal/consortium-personal-seguros/consortium-personal-seguros.html',
                    controller: 'ConsortiumPersonalSeguroController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('consortium-personal-seguros.new', {
                parent: 'consortium-personal-seguros',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-personal/consortium-personal-seguros/consortium-personal-seguros-new.html',
                    controller: 'ConsortiumPersonalSeguroNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'consortium-personal-seguros'
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'consortium-personal-seguros',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            }).state('consortium-personal-seguros.edit', {
                parent: 'consortium-personal-seguros',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumPersonalSeguro'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-personal/consortium-personal-seguros/consortium-personal-seguros-detail.html',
                        controller: 'ConsortiumPersonalSeguroDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Lista',
                      parent: 'consortium-personal-seguros'
                },
                resolve: {
                    entity: ['$stateParams', 'ConsortiumPersonalSeguro', function($stateParams, ConsortiumPersonalSeguro) {
                        return ConsortiumPersonalSeguro.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-personal-seguros',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }

})();
